import { render, staticRenderFns } from "./watch-playlist-view.vue?vue&type=template&id=7f18c52f&scoped=true&"
import script from "./watch-playlist-view.vue?vue&type=script&lang=js&"
export * from "./watch-playlist-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f18c52f",
  null
  
)

export default component.exports